import { ref, computed } from "vue";
import { useStore } from "@/store";
const store = useStore();
const activeRowModal: any = ref({ data: null });
import { GeneralActionTypes } from "@/store/modules/general/action-types";

function getRegistryHiveById(value: number): string | undefined {
    const registryHives = computed(() => store.state.general.enums['RegistryHive'] || [])
    const folder = registryHives.value.find((item: any) => item.value === value);
    return folder?.label;
}
function getAppliesToById(value: number): string | undefined {
    const appliesToOptions = computed(() => store.state.general.enums['AppliesTo'] || [])
    const folder = appliesToOptions.value.find((item: any) => item.value === value);
    return folder?.label;
}
function getAccessControlById(value: number): string | undefined {
    const accessControlOptions = computed(() => store.state.general.enums['AccessControl'] || [])
    const folder = accessControlOptions.value.find((item: any) => item.value === value);
    return folder?.label;
}
const data = {
    filter: {
        title: "registryAccessfilter",
        pageName: "registryAccessfilter",
        genre: "registryAccessPageFilter",
        ignoreSaveFilter: true,
        noDateSelect: true,
        hideFilter: false,
        //quickSearch: "fullTextSearch",
        filters: [
        ],
    },
    header: {
        navigation: [

        ],
        buttonPosition: "pr-4 justify-content-between",
        buttons: [

        ],
    },
    component: {
        type: "ag-table",
        options: {
            columns: [
                {
                    label: "REGISTRY KEY",
                    field: "registryKey",
                    sortable: false,
                    display: (row: any) => {
                        let registryHive = null;
                        const registryKey = row.registryKey || "";
                        if (row.registryHive) {
                            registryHive = getRegistryHiveById(row.registryHive);
                        }
                        let html = "<div class='d-flex flex-column align-items-start'>";

                        html += "<span style='color: #01172F; font-weight: bold;'>" + registryHive + "</span>";
                        html += "<span style='color: #01172F; '>" + registryKey + "</span>";
                        if (row.enabled === false) {
                            html += "<div class='d-flex align-items-center' style='margin-top:10px'><i class='ag-icon ag-icon_warning_filled' style='font-size:0.8em !important;'></i><span style='font-size:0.7em; color:#636363'>This rule is disabled and will not be published</span></div>";
                        }
                        html += "</div>";
                        return html;
                    },
                    width: "40%",
                },
                {
                    label: "REGISTRY VALUE",
                    field: "registryValue",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        const registryValue = row.registryValue ?? "";
                        return `<span style='color: #01172F;'>${registryValue}</span>`;
                    },
                    width: "10%",
                },
                {
                    label: "ACCESS CONTROL",
                    field: "accessControl", 
                    display: (row: any) => {
                        const accessControl =row.accessControl ? getAccessControlById(row.accessControl) : "";
                        return `<span style='color: #01172F;'>${accessControl}</span>`;
                    },
                    sortable: true,
                    jsSort: true,
                    width: "15%",
                },
                {
                    label: "APPLIES TO",
                    field: "appliesTo",
                    display: (row: any) => {
                        const appliesTo =row.appliesTo ? getAppliesToById(row.appliesTo) : "";
                        return `<span style='color: #01172F;'>${appliesTo}</span>`;
                    },
                    sortable: true,
                    jsSort: true,
                    width: "15%",
                },
                {
                    label: "ACTION",
                    field: "commands",
                    components: [
                        {
                            component: "appGroupTableEditComponent",
                        },
                        {
                            component: "copyAction",
                            class: "mr-2 ml-2",
                        },
                        {
                            component: "appGroupDeleteComponent",
                        },
                    ],
                    width: "120px",
                
                },
            ],
            rows: [],
            total: 0,
            sortable: {
                order: "",
                sort: "asc",
            },
            page: 0,
            pageSize: 0,
            showPagination: false,
            isLoading: true,
            dateFilter: false,
            zebra: true,
            separateBorders: true,
            editOnRowClick: true,
            fetchTable: (options: any) => {
                store.dispatch(GeneralActionTypes.GET_APPGROUP_REGISTRY, {
                    options: options,
                    filters: {}
                });
            }
        },
    },

};

export default data;
